import React from "react";
import { AppBar, CircularProgress, IconButton, Toolbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

interface DrawerHeaderProps {
  title?: React.ReactNode | string;
  isLoading?: boolean;
  onClose?: () => void;
}

const DrawerHeader = ({
  title,
  isLoading = false,
  onClose = () => {},
}: DrawerHeaderProps) => {
  return (
    <AppBar position="sticky">
      <Toolbar variant="dense">
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>

        {isLoading && <CircularProgress size={25} color="secondary" />}

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[300],
          }}
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default DrawerHeader;
